export const mockData = {
  services: [
    {
      id: 'pmos-support',
      title: 'PMOS Support',
      description: 'Comprehensive care for Polyendocrine Metabolic Ovarian Syndrome (formerly PCOS) with focus on cycle regulation and metabolic balance',
      symptoms: ['Irregular periods', 'Weight resistance', 'Acne', 'Excess hair growth', 'Fatigue', 'Insulin resistance', 'Fertility challenges'],
      included: ['Hormone panel with insulin markers', 'Cycle regulation protocols', 'Metabolic support plan', 'Ongoing symptom management']
    },
    {
      id: 'pmdd-support',
      title: 'PMDD Support',
      description: 'Targeted care for severe cycle-related mood symptoms and premenstrual dysphoric disorder',
      symptoms: ['Severe mood swings', 'Depression before period', 'Intense irritability', 'Anxiety', 'Hopelessness'],
      included: ['Cycle tracking analysis', 'Targeted hormone support', 'Mood stabilization protocols', 'Ongoing symptom management']
    },
    {
      id: 'postpartum-support',
      title: 'Postpartum Support',
      description: 'Comprehensive hormone and nervous system support after pregnancy and childbirth',
      symptoms: ['Fatigue', 'Mood changes or anxiety', 'Postpartum depression symptoms', 'Hair loss', 'Sleep disruption', 'Brain fog', 'Hormonal imbalance'],
      included: ['Comprehensive hormone panel', 'Personalized postpartum care plan', 'Targeted hormone and nutrient support', 'Ongoing symptom management']
    },
    {
      id: 'perimenopause-support',
      title: 'Perimenopause Support',
      description: 'Targeted care for hormonal shifts during the perimenopausal transition',
      symptoms: ['Irregular cycles', 'Hot flashes or night sweats', 'Mood swings or anxiety', 'Sleep disturbances', 'Weight changes', 'Low libido', 'Brain fog'],
      included: ['Comprehensive hormone testing', 'Personalized treatment plan', 'Cycle and symptom tracking support', 'Ongoing hormone management']
    },
    {
      id: 'hormone-optimization',
      title: 'Hormone Optimization',
      description: 'Bioidentical hormone therapy, cycle support, and perimenopause management',
      symptoms: ['Irregular cycles', 'PMS', 'Hot flashes', 'Night sweats', 'Mood swings'],
      included: ['Comprehensive hormone panel', 'Personalized treatment plan', 'Monthly follow-ups', 'Ongoing support']
    },
    {
      id: 'thyroid-support',
      title: 'Thyroid Support',
      description: 'Comprehensive thyroid care for Hashimoto\'s and hypothyroidism',
      symptoms: ['Fatigue', 'Weight gain', 'Hair loss', 'Cold sensitivity', 'Brain fog'],
      included: ['Complete thyroid testing', 'Medication management', 'Nutritional guidance', 'Symptom tracking']
    },
    {
      id: 'metabolic-stress-support',
      title: 'Metabolic & Stress Support',
      description: 'Address insulin resistance, cortisol imbalance, fatigue, and burnout',
      symptoms: ['Weight resistance', 'Chronic fatigue', 'Sugar cravings', 'Anxiety', 'Sleep issues', 'Low stress tolerance'],
      included: ['Metabolic and cortisol testing', 'Insulin optimization', 'Stress management strategies', 'Sleep and recovery protocols']
    },
    {
      id: 'menopause-support',
      title: 'Menopause Support',
      description: 'Comprehensive care for menopause transition',
      symptoms: ['Hot flashes', 'Mood changes', 'Low libido', 'Sleep disruption', 'Vaginal dryness'],
      included: ['Hormone replacement therapy', 'Symptom management', 'Bone health support', 'Sexual wellness']
    }
  ],
  testimonials: [
    {
      id: 1,
      name: 'Sarah M.',
      age: 42,
      quote: 'After years of being dismissed by doctors, Glow Health finally listened. I have my energy back and feel like myself again.',
      condition: 'Perimenopause'
    },
    {
      id: 2,
      name: 'Jennifer L.',
      age: 38,
      quote: 'The personalized approach made all the difference. They didn\'t just treat my labs,they treated me as a whole person.',
      condition: 'Thyroid Imbalance'
    },
    {
      id: 3,
      name: 'Michelle K.',
      age: 45,
      quote: 'I finally have answers. The brain fog is gone, my mood is stable, and I\'m sleeping through the night.',
      condition: 'Hormone Optimization'
    }
  ],
  pricing: [
    {
      id: 'membership',
      name: 'Glow Health Membership',
      price: '$99/month',
      description: 'Complete hormone health care with predictable monthly pricing',
      includes: [
        'Onboarding consultation',
        'Ongoing prescription management',
        'Structured provider communication',
        'Periodic lab review'
      ]
    }
  ],
  labPackages: [
    {
      id: 'basic',
      name: 'Basic Hormone Panel',
      price: '$150',
      tests: ['Estrogen', 'Progesterone', 'Testosterone', 'DHEA', 'Cortisol']
    },
    {
      id: 'comprehensive',
      name: 'Comprehensive Metabolic Panel',
      price: '$250',
      tests: ['Full hormone panel', 'Thyroid complete', 'Insulin', 'HbA1c', 'Lipid panel', 'Inflammatory markers']
    },
    {
      id: 'advanced',
      name: 'Advanced Optimization Panel',
      price: '$350',
      tests: ['Complete hormone profile', 'Thyroid with antibodies', 'Metabolic markers', 'Nutrient levels', 'Genetic markers']
    }
  ]
};